import { Box, IconButton, Chip, Typography, Tooltip } from "@mui/material";
import { chipStyle, headerBoxStyle } from "../styles/styles";
import { useTranslation } from "react-i18next";
import { formatDateToDDMYY } from "../../../Utils/dateFormat";

const STATUS_COLOR_MAP = {
  orange: {
    backgroundColor: "rgba(255, 151, 51, 0.16)",
    color: "rgba(255, 151, 51, 1)",
  },
  green: {
    backgroundColor: "rgba(40, 199, 111, 0.16)",
    color: "rgba(40, 199, 111, 1)",
  },
  grey: {
    backgroundColor: "rgba(72, 72, 72, 0.16)",
    color: "rgba(72, 72, 72, 1)",
  },
  red: {
    backgroundColor: "rgba(183, 72, 74, 0.16)",
    color: "rgba(183, 72, 74, 1)",
  },
};

const VIEW_TYPE_COLOR_MAP = {
  pending: "orange",
  active: "green",
  completed: "green",
  missed: "grey",
  cancelled: "red",
};

const ViewJobHeader = (props) => {
  const { jobData, viewType, onClose } = props;

  const { t, i18n } = useTranslation("view-job-modal");
  const { job_id, status_tag } = jobData;

  const isHebrew = i18n.language === "he";
  const arrowIcon = isHebrew ? "/right_arrow_icon.svg" : "/left_arrow_icon.svg";

  const handleCancel = () => {
    onClose();
  };

  // The header stays the same in edit mode (Job id + status chip + close). The
  // "back to order details" link + subtitle live at the top of the editor
  // panel itself (see EditOrder), matching Figma.
  const displayStatus = status_tag?.text?.toLowerCase() === "cancelled"
    ? "cancelled"
    : viewType || status_tag?.text?.toLowerCase();
  // Product order returned to the member: keep it orange (still pending) but
  // label it "Waiting for customer approval" instead of plain "Pending".
  const headerTag = jobData?.awaiting_member
    ? t("awaiting_member")
    : displayStatus === "completed" && jobData.completed_on
      ? `${t(displayStatus)} | ${formatDateToDDMYY(jobData.completed_on)}`
      : t(displayStatus);

  const statusColorKey = VIEW_TYPE_COLOR_MAP[displayStatus] || status_tag?.color;
  const statusColor =
    STATUS_COLOR_MAP[statusColorKey] || STATUS_COLOR_MAP.green;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      flexWrap="wrap"
      alignItems="center"
      sx={headerBoxStyle}
    >
      <Box display="flex" alignItems="center" gap="12px">
        <Box
          onClick={handleCancel}
          sx={{ cursor: "pointer", display: { xs: "flex", sm: "none" } }}
        >
          <img src={arrowIcon} alt="left_arrow_icon" />
        </Box>

        <Typography
          sx={{
            color: "rgba(72, 72, 72, 1)",
            lineHeight: "38px",
            fontSize: "18px",
            fontWeight: "500",
          }}
        >
          {t("job")} (
          <Tooltip title={String(job_id)} arrow>
            <span style={{ cursor: "pointer" }}>{String(job_id).slice(0, 4)}</span>
          </Tooltip>
          )
        </Typography>

        {headerTag && (
          <Chip
            label={headerTag}
            sx={{
              backgroundColor: statusColor.backgroundColor,
              color: statusColor.color,
              ...chipStyle,
            }}
          />
        )}
      </Box>

      <Box
        display="flex"
        alignItems="center"
        gap="2px"
        sx={{ display: { xs: "none", sm: "flex" } }}
      >
        <IconButton onClick={handleCancel}>
          <img src="/cancel_icon.svg" alt="close" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ViewJobHeader;
